<template>
    <div class="row" :id="table_id">
        <div class="col-lg-8 col-md-3">
            <div v-if="table_id === 'terminal_goods_warehouse_table' || table_id.startsWith('terminal_goods_warehouse_table_')">
                <input v-on:input="filterInput()" v-model="show_negative_quantity_goods" type="checkbox" value="1" name="show_negative_quantity_goods" id="show_negative_quantity_goods"/> <label for="show_negative_quantity_goods">{{ show_negative_quantity_goods_trans }}</label>
            </div>
        </div>
        <div class="col-lg-4 col-md-9 col-12 text-right">
            <div class="widesearch">
                <i class='fa fa-search'></i><input type="text" v-model="widesearch" name="widesearch" class="widesearch-input" v-on:input="filterInput()"/><i class="fa fa-close filter-close-btn" @click="clearWideSearch()"></i>
            </div>
        </div>
        <div class="col-12 main-data-table-container sticky-hscroll">
            <div class="filters-posted">
                <div v-for="(value, key) in filter_values" class="selected-filter-div" v-if="value.length">
                    <div v-for="header in headers" v-if="header.key == key">
                        <div class="selected-filter-label">{{ header.trans }}</div><div class="selected-filter-count"><span class="selected-filter-count-span" v-if="header.filter_type == 'date_range'">1</span><span class="selected-filter-count-span" v-else>{{ value.length }}</span></div><div class="text-right filter-box-off selected-filter-remove" style="display:inline" @click="removeSelectedFilter(key)"><i class="fa fa-close filter-close-btn"></i></div>
                    </div>
                </div>
                <div class="clear-all-filters-div" v-if="getFilterValuesLength()" @click="removeAllFilters()">Išvalyti visus filtrus</div>
            </div>
            <table class="table table-striped main-data-table">
                <thead class="main-thead">
                    <tr class="headers" style="text-align: center; cursor: pointer;">
                        <datatables-header-column-component 
                            v-for="header in headers"
                            :key="header.key"
                            :col_key="header.key"
                            :class="header.head_classes"
                            :text="header.trans"
                            :sorting_key="sorting_key"
                            :sorting_direction="sorting_direction"
                            :style="header.head_styles"
                            :title="header.title"
                        />
                    </tr>
                    <tr v-if="filter_header" class="filters">
                        <th v-for="header in headers" :key="header.key" :class="[header.head_classes]">
                            <div class="filter-container">
                                <div class="form-control filter-input-sm table-header-filter" @click="toggleTooltip(header.key)" v-if="header.filter_type"><span style="float:left"><i class="glyphicon glyphicon-filter"></i>&nbsp;Filtruoti</span><i style="float:right" class="glyphicon glyphicon-chevron-down"></i></div>
                                <div class="filter-tooltip" :data-header-key="header.key">
                                    <div class="text-right filter-box-off"><i class="fa fa-close filter-close-btn" @click="toggleTooltip(header.key)"></i></div>
                                    <div class="filter-input-box">
                                        <select multiple class="form-control filter-input" v-if="header.filter_type != 'date_range'"
                                            :class="[header.key + '_select2', header.search_type]"
                                            v-select2
                                            v-model="filter_values[header.key]"
                                            :data-url="header.filter_url"
                                            :data-additional="header.filterDataAdditional || '{}'"
                                            :data-multiple="true"
                                            :data-search-placeholder="header.placeholder"
                                            :data-maximum-selection-size="header.maximum_selection_size"
                                        ></select>
                                        <input type="text" style="font-size: 0.75rem;" class="form-control filter-input vue-datatables-dateranger-filter"
                                            v-if="header.filter_type == 'date_range'"
                                            :data-header-key="header.key"
                                            v-model="filter_values[header.key]"
                                        >
                                    </div>
                                    <div style="float:right" class="text-right">
                                        <div class="filter-btn filter-btn-cancel" @click="removeSelectedFilter(header.key)">Išvalyti</div>
                                        <div class="filter-btn filter-btn-filter" @click="filterInput()">Filtruoti</div>
                                    </div>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="spinner" :id="'spinner_' + table_id">
                    <tr>
                        <td class="text-center" :colspan="headers.length">
                            <i class="fa fa-cog fa-spin fa-4x"></i>
                        </td>
                    </tr>
                </tbody>
                <tbody class="main-tbody" :table="table_id" style="display: none;">
                    <tr v-for="(row, row_index) in table_data[current_page]" :key="row_index" class="datatable-tr" @dblclick="editRowEntry(row)">
                        <template v-for="(header, header_index) in headers">
                            <slot :name="header.key" :data="row" :header="header">
                                <td
                                    :key="header_index"
                                    :table="table_id"
                                    :col_key="header.key"
                                    :class="[header.cell_classes]"
                                    :title="header.title && row[header.key] && row[header.key].length > 40 ? row[header.key] : ''"
                                    v-html="header.title && row[header.key] && row[header.key].length > 40 ? row[header.key].slice(0, 40) + '...' : header.round ? roundNumber(row[header.key]) : row[header.key]">
                                </td>
                            </slot>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12" :id="`${table_id}_pagination`" v-if="pagination">
            <nav>
                <ul class="pagination justify-content-center">
                    <li v-if="current_page == 1" class="page-item disabled" aria-disabled="true" aria-label="« First">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-backward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(1)" type="button" class="page-link"  aria-label="« First">
                            <i class="fa fa-fast-backward" style="color: #3699ff;"></i>
                        </button>
                    </li>

                    <li v-if="current_page == 1" class="page-item disabled" aria-disabled="true" aria-label="« Previuos">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-backward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(current_page-1)" type="button" class="page-link"  rel="prev" aria-label="« Previuos">
                            <i class="fa fa-backward" style="color: #3699ff;"></i>
                        </button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [4, 3, 2, 1]" :key="`${_}-before`" v-show="current_page-i >= 1">
                        <button @click="changePage(current_page-i)" type="button" class="page-link">{{ current_page-i }}</button>
                    </li>

                    <li class="page-item active">
                        <button type="button" class="page-link">{{ current_page }}</button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [1, 2, 3, 4]" :key="`${_}-after`" v-show="current_page+i <= page_count">
                        <button @click="changePage(current_page+i)" type="button" class="page-link">{{ current_page+i }}</button>
                    </li>

                    <li v-if="current_page == page_count" class="page-item disabled" aria-disabled="true" aria-label="Next »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(current_page+1)" type="button" class="page-link" rel="next" aria-label="Next »">
                            <i class="fa fa-forward" style="color: #3699ff;"></i>
                            </button>
                    </li>

                    <li v-if="current_page == page_count" class="page-item disabled" aria-disabled="true" aria-label="Last »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(page_count)" type="button" class="page-link" aria-label="Last »">
                            <i class="fa fa-fast-forward" style="color: #3699ff;"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            'activeTooltip': null,
            'headers': [],
            'filter_values': {},
            'table_data': {},
            'current_page': 1,
            'per_page': 20,
            'request_number': 1,
            'header_keys': [],
            'page_count': 1,
            'loaded_pages': [],
            'sorting_key': '',
            'sorting_dir': '',
            'filter_timer': null,
            'widesearch': '',
            'show_negative_quantity_goods': false,
        }
    },
    props: {
        'table_id': {
            'type': String,
            'required': true,
        },
        'sort_key': {
            'type': String,
            'required': false,
            'default': 'id'
        },
        'sort_dir': {
            'type': String,
            'required': false,
            'default': 'asc',
        },
        'headers_json': {
            'type': String,
            'required': true,
        },
        'filter_header': {
            'type': Boolean,
            'required': false,
            'default': false,
        },
        'data_url': {
            'type': String,
            'required': true,
        },
        'skip_sorting_header': {
            'type': Boolean,
            'required': false,
            'default': false,
        },
        'non_sorting': {
            'type': Array,
            'required': false,
            'default': function(){
                return [];
            },
        },
        'edit_url': {
            'type': String,
            'required': false,
            'default': '#',
        },
        'destroy_url': {
            'type': String,
            'required': false,
            'default': '#',
        },
        'pagination': {
            'type': Boolean,
            'required': false,
            'default': true,
        },
        'show_negative_quantity_goods_trans': {
            'type': String,
            'required': false,
        },
    },
    created: function(){
        let vue = this;

        vue.headers = JSON.parse(Base64.decode(vue.headers_json));

        vue.sorting_key = vue.sort_key;
        vue.sorting_direction = vue.sort_dir;

        $.each(vue.headers, function(index, element){
            vue.header_keys.push(element['key']);
            vue.$set(vue.filter_values, element['key'], []);
        });

        vue.$nextTick(function () {
            let items = $('.vue-datatables-dateranger-filter');

            let complete_locale = window.daterangepicker_locales[window.locale];
            complete_locale['format'] = 'YYYY-MM-DD';

            items.daterangepicker({
                'locale': complete_locale,
                'linkedCalendars': false,
            });

            items.on('apply.daterangepicker', function () {
                vue.filter_values[$(this).data('header-key')] = $(this).val();
                vue.filterInput();
            });

            items.on('cancel.daterangepicker', function () {
                vue.filter_values[$(this).data('header-key')] = null;
                vue.filterInput();
            });

            items.attr('autocomplete', 'off');
        });

        vue.completeDataRefresh();
        vue.getFilterValuesLength();
    },
    methods: {
        roundNumber(value, decimals = 2) {
            if (isNaN(value)) {
                return value;
            }

            const roundedValue = Number(Math.round(Number(value) + "e" + decimals) + "e-" + decimals);

            return roundedValue.toFixed(decimals);
        },
        editRowEntry(row) {
            if (row.edit_route) {
                window.location.href = row.edit_route;
            }
        },
        clearWideSearch() {
            this.widesearch = '';
            this.filterInput();
        },
        getFilterValuesLength () {
            return Object.values(this.filter_values).some(value => value.length > 0);
        },
        toggleTooltip(tooltip) {
            $(".filter-tooltip").not('[data-header-key="' + tooltip + '"]').css('display', 'none');
            $(".filter-tooltip[data-header-key='" + tooltip + "']").toggle();
        },
        removeSelectedFilter(key) {
            let vue = this;

            if (key in this.filter_values) {
                this.$set(this.filter_values, key, []);
                $('.'+key+'_select2').val(null).trigger('change');
                $(".filter-tooltip").css('display', 'none');
                this.filterInput();
            }
        },
        removeAllFilters() {
            let vue = this;

            $.each(vue.filter_values, function(key, element) {
                vue.$set(vue.filter_values, key, []);
                $('.'+key+'_select2').val(null).trigger('change');
            });
            $(".filter-tooltip").css('display', 'none');
            this.filterInput();
        },
        sortCol(col_key) {
            let vue = this;

            if (vue.skip_sorting_header || vue.non_sorting.includes(col_key)) {
                return;
            }

            if (vue.sorting_key == col_key) {
                vue.sorting_direction = (vue.sorting_direction == 'desc' ? 'asc' : 'desc');
            } else{
                vue.sorting_direction = 'asc'
            }

            vue.sorting_key = col_key;
            vue.completeDataRefresh();
        },
        filterInput() {
            let vue = this;

            if (vue.filter_timer) {
                clearTimeout(vue.filter_timer);
                vue.filter_timer = null;
            }

            vue.filter_timer = setTimeout(function() {
                vue.completeDataRefresh();
            }, 100);

            $(".filter-tooltip").css('display', 'none');
        },
        completeDataRefresh() {
            let vue = this;

            vue.current_page = 1;
            vue.table_data = {};
            vue.loaded_pages = [];

            vue.loadCurrentPage();
        },
        loadCurrentPage() {
            let vue = this;

            if (vue.loaded_pages.includes(vue.current_page)) {
                $('.main-tbody').show();
                $('#spinner_' + vue.table_id).hide();
                return;
            }

            vue.request_number++;

            let request_data = {
                'request_number': vue.request_number,
                'sort_key': vue.sorting_key,
                'sort_dir': vue.sorting_direction,
                'page': vue.current_page,
                'per_page': vue.per_page,
                'columns': vue.header_keys,
                'filters': vue.filter_values,
                'widesearch': vue.widesearch,
                'show_negative_quantity_goods': vue.show_negative_quantity_goods,
            };

            axios.post(vue.data_url, request_data)
            .then(function(response) {
                if (response.data.request_number != vue.request_number) {
                    return;
                }

                vue.current_page = parseInt(response.data.page);
                vue.page_count = parseInt(response.data.total_pages);

                if (response.data.table_data.length > 0) {
                    vue.table_data[vue.current_page] = response.data.table_data;
                    vue.loaded_pages.push(response.data.page);
                }

                $('.main-tbody').show();
                $('#spinner_' + vue.table_id).hide();

                vue.$forceUpdate();
            })
            .catch(function(error) {
                console.error(error);
            });

        },
        changePage(new_page) {
            let vue = this;
            if (new_page < 0 || new_page > vue.total_pages || new_page == vue.current_page) {
                return;
            }

            vue.current_page = new_page;
            vue.loadCurrentPage();
        },
    }
}
</script>
